import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import type { Participant } from "../../models/api/participant";
import type { RootState } from "../../store";
import { FinancialProfileFooter } from "../financial-profile/financial-profile-footer.component";
import { ProfileSection } from "../financial-profile/financial-profile-section.component";
import { drawerMenuStyles } from "./drawer-menu.styles";
import { HeaderScreen } from "./header-screen.component";

interface ProfileScreenProps {
  setScreen: (screen: string[]) => void;
  onClose: () => void;
  onBack: () => void;
}

export const ProfileScreen = (props: ProfileScreenProps) => {
  const { setScreen, onClose, onBack } = props;
  const classes = drawerMenuStyles();
  const participantProfile = useSelector<RootState, Participant>(
    (state) => state.profile
  );

  return (
    <Grid
      container
      className={classes.profileScreen}
      data-testid="profile-screen"
    >
      <HeaderScreen title="Financial Profile" onBack={onBack} />
      <ProfileSection
        isMobile
        participantProfile={participantProfile}
        handleClose={onClose}
        setScreen={setScreen}
      />
      <FinancialProfileFooter handleClose={onClose} isMobile />
    </Grid>
  );
};
